export default {"src":"/_next/static/media/btc.63077225.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};